import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET: 'PARENT_LEAD_GET',
  GET_SUCCESS: 'PARENT_LEAD_GET_SUCCESS',
  GET_FAILURE: 'PARENT_LEAD_GET_FAILURE',
  POST: 'PARENT_LEAD_POST',
  POST_SUCCESS: 'PARENT_LEAD_POST_SUCCESS',
  POST_FAILURE: 'PARENT_LEAD_POST_FAILURE',
  POST_STUDENT: 'PARENT_LEAD_POST_STUDENT',
  POST_SUCCESS_STUDENT: 'PARENT_LEAD_POST_STUDENT_SUCCESS',
  POST_FAILURE_STUDENT: 'PARENT_LEAD_POST_STUDENT_FAILURE',
  PATCH: 'PARENT_LEAD_PATCH',
  PATCH_SUCCESS: 'PARENT_LEAD_PATCH_SUCCESS',
  PATCH_FAILURE: 'PARENT_LEAD_PATCH_FAILURE',
};

export const get = actions.get(
  (id, { country_code: countryCode, phone }) =>
    `${BASE_URL}/lead?phone=${countryCode}-${phone}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const post = actions.post(() => `${BASE_URL}/parents/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const postStudent = actions.post(
  parentId => `${BASE_URL}/parents/${parentId}/student/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);

export const patch = actions.patch(parentId => `${BASE_URL}/parents/${parentId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
